import { TWebhookMappingRow } from "../types";

export type TWebhookTemplate = {
  id: string;
  name: string;
  description: string;
  webhook_url: string;
  headers: Record<string, string>;
  mappings: Omit<TWebhookMappingRow, "id">[];
};

export const DEFAULT_SAMPLE_SUBMISSION = {
  clinic_uuid: "clinic-123",
  form_data: {
    formName: "Consultation Intake",
    submitted_at: "2024-01-01T09:30:00Z",
  },
  patient_record: {
    first_name: "Avery",
    last_name: "Stone",
    phone: "+1 555-0100",
    email: "avery.stone@example.com",
    location: "Main Clinic",
    procedures_of_interest: ["Botox", "Fillers"],
  },
  photo_urls: [
    "https://cdn.clinicos.app/forms/photo-1.jpg",
    "https://cdn.clinicos.app/forms/photo-2.jpg",
  ],
};

export const REQUIRED_SOURCE_PATHS = [
  "patient_record.first_name",
  "patient_record.last_name",
  "patient_record.phone",
  "patient_record.location",
  "patient_record.procedures_of_interest",
  "photo_urls[0]",
  "photo_urls[1]",
];

export const WEBHOOK_TEMPLATES: TWebhookTemplate[] = [
  {
    id: "leadconnector",
    name: "LeadConnector",
    description: "Send form submissions into LeadConnector.",
    webhook_url:
      "https://services.leadconnectorhq.com/hooks/abc123/webhook-trigger/xyz",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer replace-with-token",
    },
    mappings: [
      {
        target_field: "contact.firstName",
        source_path: "patient_record.first_name",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
      {
        target_field: "contact.lastName",
        source_path: "patient_record.last_name",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
      {
        target_field: "contact.phone",
        source_path: "patient_record.phone",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
      {
        target_field: "contact.location",
        source_path: "patient_record.location",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
      {
        target_field: "contact.proceduresOfInterest",
        source_path: "patient_record.procedures_of_interest",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
      {
        target_field: "contact.photoUrls[0]",
        source_path: "photo_urls[0]",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
    ],
  },
  {
    id: "liine",
    name: "Liine",
    description: "Send leads to Liine.",
    webhook_url:
      "https://alice.liine.com/api/form/695cd193-fc80-4dad-8694-d263cdee7e06/lead",
    headers: {
      "Content-Type": "application/json",
    },
    mappings: [
      {
        target_field: "lead.first_name",
        source_path: "patient_record.first_name",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
      {
        target_field: "lead.last_name",
        source_path: "patient_record.last_name",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
      {
        target_field: "lead.email",
        source_path: "patient_record.email",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
      {
        target_field: "lead.phone_number",
        source_path: "patient_record.phone",
        default_value: "",
        literal_value: "",
        include_if_none: false,
      },
      {
        target_field: "lead.source",
        source_path: "",
        default_value: "Clinicos",
        literal_value: "",
        include_if_none: false,
      },
    ],
  },
  {
    id: "slack",
    name: "Slack",
    description: "Send notifications to a Slack webhook.",
    webhook_url: "https://hooks.slack.com/services/T0000/B0000/REPLACE",
    headers: {
      "Content-Type": "application/json",
    },
    mappings: [
      {
        target_field: "text",
        source_path: "",
        default_value: "",
        literal_value: "New Clinicos submission received",
        include_if_none: false,
      },
      {
        target_field: "attachments[0].fields[0].title",
        source_path: "",
        default_value: "",
        literal_value: "Patient",
        include_if_none: false,
      },
      {
        target_field: "attachments[0].fields[0].value",
        source_path: "patient_record.first_name",
        default_value: "Unknown",
        literal_value: "",
        include_if_none: false,
      },
    ],
  },
  {
    id: "blank",
    name: "Blank",
    description: "Start from an empty mapping.",
    webhook_url: "",
    headers: {
      "Content-Type": "application/json",
    },
    mappings: [],
  },
];
